import styled, { css } from 'styled-components'
import { Chip } from '.'
import { useHistory } from 'react-router-dom'

export function AppChip({
  type,
  hideLogo,
  size,
}: {
  type: 'labs' | 'launch' | 'drops'
  hideLogo?: boolean
  size?: 's' | 'l'
}) {
  const history = useHistory()
  function navToPage() {
    history.push(`/${type === 'launch' ? 'memecoins' : type}`)
  }
  return (
    <AppChipBox size={size} onClick={navToPage}>
      {!hideLogo && (
        <img src={`/icon-${type}.svg`} alt={type} className="icon-logo" />
      )}
      <img
        src={`/img/logos/app-logos/${type}${size === 's' ? '-small' : ''}.svg`}
        alt={`${type} Logo`}
      />
    </AppChipBox>
  )
}

const AppChipBox = styled(Chip) <{ size?: 's' | 'l' }>`
  display: flex;
  padding: var(--units-8, 8px) var(--units-12, 12px) var(--units-8, 8px)
    var(--units-8, 8px);
  align-items: center;
  gap: 3px;
  border-radius: 44;
  background: linear-gradient(0deg, var(--surface-minimal-alpha-primary, rgba(255, 255, 255, 0.04)) 0%, var(--surface-minimal-alpha-primary, rgba(255, 255, 255, 0.04)) 100%), var(--surface-primary, #080808);
  // not a theme color but if I do a border of this color the opacity goes weird
  // go horse but the rest of Barry is robust so deal with it
  border: 1px solid #181818;
  img {
    filter: saturate(0);
  }
  ${({ size }) =>
    size === 's' &&
    css`
      img.icon-logo {
        width: 12px;
        height: 16px;
      }
    `}
  :hover{
    cursor:pointer;
    border: 0.762px solid var(--stroke-secondary, #333);
    background: linear-gradient(0deg, var(--states-minimal-alpha-4, rgba(255, 255, 255, 0.04)) 0%, var(--states-minimal-alpha-4, rgba(255, 255, 255, 0.04)) 100%), linear-gradient(0deg, var(--surface-minimal-alpha-primary, rgba(255, 255, 255, 0.04)) 0%, var(--surface-minimal-alpha-primary, rgba(255, 255, 255, 0.04)) 100%), var(--surface-primary, #080808);
  }
`
